"use client";

import { useTranslations } from "next-intl";
import { useConsent } from "@/components/analytics/PostHogProvider";

/**
 * Footer "Manage cookies" affordance — re-opens the consent banner so a visitor
 * can change or withdraw their analytics choice. Renders nothing when analytics
 * isn't configured (no key) so there's no dead link in local/preview. Uses React
 * context + useTranslations only (no usePathname/useSearchParams), so it stays
 * safe inside the prerendered footer shell.
 */
export default function ManageCookiesLink() {
  const t = useTranslations("consent");
  const { analyticsEnabled, reopen } = useConsent();

  if (!analyticsEnabled) return null;

  return (
    <li>
      <button
        type="button"
        onClick={reopen}
        className="text-sm text-gray-600 transition-colors hover:text-navy"
      >
        {t("manageCookies")}
      </button>
    </li>
  );
}
